/** Environment reads shared between src/lib/feedback.ts, src/lib/usageTracking.ts, and src/lib/errorReporting.ts. Kept narrow — feedback.ts still reads navigator.language on its own, since that isn't needed by usage_events or error_events. */
export interface ClientEnvironment {
  userAgent: string;
  screenWidth: number;
  screenHeight: number;
  devicePixelRatio: number;
  timezone: string;
}

export function captureClientEnvironment(): ClientEnvironment {
  return {
    userAgent: navigator.userAgent,
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    devicePixelRatio: window.devicePixelRatio,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };
}

/** e.g. "636d05e, deployed Aug 26" — promoted out of feedback.ts (backlog ADMIN-9) once errorReporting.ts became a second consumer. */
export function formattedAppVersion(): string {
  const date = new Date(__BUILD_TIME__).toLocaleDateString("en-US", { month: "short", day: "numeric" });
  return `${__APP_VERSION__}, deployed ${date}`;
}
